/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.IdentifyTheFeeling.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.IdentifyTheFeeling, 24]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.IdentifyTheFeeling.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.choices = [];
  this.expression = null;
};

EDC.Games.IdentifyTheFeeling.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.IdentifyTheFeeling.Scenes.Main.prototype.constructor = EDC.Games.IdentifyTheFeeling.Scenes.Main;

const ITF = EDC.Games.IdentifyTheFeeling.Scenes.Main.prototype;

ITF.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

ITF.loadIteration = function () {
  this.createExpression();
  this.createChoices();
};

ITF.createTemplateUI = function () {
  this.add.sprite(0, 0, 'boy').setOrigin(0);
  this.add.sprite(0, 0, 'frame-box').setOrigin(0);
  this.add.sprite(595, 95, 'question-box');
};

ITF.createExpression = function () {
  const expression_id = this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer;
  this.expression = this.add.sprite(1320, 185, `expression-${expression_id}`).setOrigin(0);
};

ITF.createChoices = function () {
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices.length; i++) {
    const { position_y, scale } = this.getChoicePosition(i);
    const choice_container = this.add
      .container(590, position_y)
      .setSize(350, 90)
      .setInteractive();
    const choice_id = this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices[i];
    const choice = this.add.sprite(0, 0, `choice-${choice_id}`).setScale(scale);
    choice_container.add(choice);
    choice_container.id = choice_id;

    const markAnim = new AnswerMark(this, choice_container).setScale(0.35);
    choice_container.setData('markAnim', markAnim);

    this.cursorManager.setDefaultDraggableEvents(choice_container);
    choice_container.on('pointerdown', this.checkAnswer.bind(this, choice_container), this);
    this.choices.push(choice_container);
  }
};

ITF.getChoicePosition = function (index) {
  let position_y = 220;
  let scale = 1;
  if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices.length === 2) {
    position_y = 330 + index * 250;
    scale = 1.5;
  } else if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices.length === 4) {
    position_y = 240 + index * 140;
    scale = 1.2;
  } else if (this.gameConfig.sets[this.difficulty].iterations[this.iteration].choices.length === 6) {
    position_y = 210 + index * 95;
    scale = 0.8;
  }
  return { position_y, scale };
};

ITF.checkAnswer = function (choice) {
  if (choice.id === this.gameConfig.sets[this.difficulty].iterations[this.iteration].correctAnswer) {
    choice.getData('markAnim').showMark(true, () => {});
    this.playCorrect();
    this.time.delayedCall(1000, this.nextIteration, [], this);
  } else {
    choice.getData('markAnim').showMark(false, () => {});
    this.playWrong();
    choice.first.setTint(0xff0000);
    choice.disableInteractive();
  }
};

ITF.nextIteration = function () {
  this.choices.map((choice) => {
    choice.destroy();
    return true;
  });
  this.choices = [];
  this.expression.destroy();
  this.expression = null;

  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default EDC.Games.IdentifyTheFeeling.Scenes.Main;
